import { IConstructionProgressImageSchema } from '../../repositories/construction-progress/entities/get_construction_progress_page/ConstructionProgressImageSchema';
import { IConstructionProgressImage } from '../../types/constructionProgress';
import { prepareImageText } from './prepareImageText';

export const prepareImage = (
  image: IConstructionProgressImageSchema,
  newbuildingName: string,
  date: string,
): IConstructionProgressImage => {
  return {
    fullUrl: image.fullUrl,
    minUrl: image.minUrl,
    housesNames: image.housesNames,
    text: prepareImageText(image, newbuildingName, date),
  };
};
